import React, { createContext, useContext, ReactNode } from "react";

export type KioskoFlow = "new" | "used" | "benefit";

export interface IKioskoConfig {
  sponsorID: string;
  name: string;
  slug: string;
  logoUrl: string;
  primaryColor: string;
  secondaryColor: string;
  bgGradientColorPrimary: string;
  bgGradientColorSecondary: string;
  // Flujos habilitados para el kiosko. Si trae uno solo (ej. ["new"]) se entra
  // directo a simply; si trae varios (["new","used"]) se muestran las cards.
  flows: KioskoFlow[];
}

const KioskoConfigContext = createContext<IKioskoConfig>({} as IKioskoConfig);

export const useKioskoConfig = () => useContext(KioskoConfigContext);

export const KioskoConfigProvider = ({
  config,
  children,
}: {
  config: IKioskoConfig;
  children: ReactNode;
}) => (
  <KioskoConfigContext.Provider value={config}>
    {children}
  </KioskoConfigContext.Provider>
);
